export const MILLISECONDS_IN_DAY = 86400000
export const FIFTEEN_MINUTES = 900000
